import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Header from "../../components/Headers/Header";
import {getCookie} from "tools/tools"
import {LangCodes, LocaleContext, TokenInput, TokenInputType} from '@skbkontur/react-ui';

import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    Card,
    CardHeader,
    Button,
    Label,
    Table,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Container,
    Media,
    Badge,
    UncontrolledTooltip,
    Progress,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    CardBody
} from "reactstrap";
import {FileUploader, Loader} from "@skbkontur/react-ui";
import FileModal from "../../components/Modals/FileModal";
import InfoModal from "../../components/Modals/InfoModal";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const MeshConverter = () => {
    const [t1File, setT1File] = useState(null);
    const [t2File, setT2File] = useState(null);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [errors, setErrors] = useState(null);
    const [convertErrors, setConvertErrors] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const {id} = useParams();
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortAsc, setSortAsc] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [pageSize, setPageSize] = useState(10); // State for dynamic page size

    const closeModal = () => setModalIsOpen(false);

    const onT1FileChange = (e) => {
        setT1File(e.target.files[0]);
    };

    const onT2FileChange = (e) => {
        setT2File(e.target.files[0]);
    };

    const onFilesUpload = async () => {
        const formData = new FormData();
        formData.append('input_t1', t1File);
        if (t2File) {
            formData.append('input_t2', t2File);
        }

        try {
            setUploading(true);
            const response = await axios.post('/api/mesh', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadPercentage(percent);
                }
            });

            console.log(response.data);
            fetchData(currentPage, sortAsc, startDate, endDate, pageSize);
            setModalData(response.data['converted_files']);
            setConvertErrors(response.data['errors'])
            setModalIsOpen(true);
        } catch (error) {
            console.log('Error uploading file:', error.response.data['errors']);
            setErrors(error.response.data['errors'])
            setModalIsOpen(true);
            alert('Error uploading file');
        } finally {
            setUploading(false);
            setUploadPercentage(0);
        }
    };

    const customLocaleForT1 = {
        FileUploader: {
            chooseFile: 'Select a T1 file',
        },
    };

    const customLocaleForT2 = {
        FileUploader: {
            chooseFile: 'Select a T2 file',
        },
    };

    const { t, i18n } = useTranslation();

    const cardBody = () => {
        return (<CardBody>
            <Form className="">
                <Label
                    className="form-control-label"
                    htmlFor="input-email"
                >
                    {t('T1')}
                </Label>
                <FormGroup>
                    <LocaleContext.Provider value={{locale: customLocaleForT1, langCode: LangCodes.en_GB}}>
                        <FileUploader onChange={onT1FileChange}/>
                    </LocaleContext.Provider>

                </FormGroup>
                <Label
                    className="form-control-label"
                    htmlFor="input-email"
                >
                    {t('T2')}
                </Label>
                <FormGroup>
                    <LocaleContext.Provider value={{locale: customLocaleForT2, langCode: LangCodes.en_GB}}>
                        <FileUploader onChange={onT2FileChange}/>
                    </LocaleContext.Provider>
                </FormGroup>
                {uploading && (
                    <Progress value={uploadPercentage} className="mb-3">
                        {uploadPercentage}%
                    </Progress>
                )}
                <Button
                    color="primary"
                    onClick={onFilesUpload}
                    disabled={!t1File || uploading}
                >
                    {uploading ? t('Creating') : t('Create')}
                </Button>
            </Form>
        </CardBody>)
    }

    const modalBody = () => {
        if (convertErrors.length !== 0) {
            return convertErrors.map((item, index) => (
                <ul key={index}>
                    <li>
                        {item}
                    </li>
                </ul>
            ))
        }

        return errors ? (`An errors has occurred: ${errors}`) : (`Creating mesh task has been running. Wait...`)


    }

    useEffect(() => {
        setCurrentPage(1);  // Сбросить на первую страницу при переходе на новый калькулятор
        fetchData(1, sortAsc, startDate, endDate, pageSize);
    }, [id]);


    useEffect(() => {
        fetchData(currentPage, sortAsc, startDate, endDate, pageSize);
    }, [currentPage, sortAsc, startDate, endDate, pageSize]);


    const fetchData = (page, sortAsc, startDate, endDate, pageSize) => {
        const sortOrder = sortAsc ? 'created_at' : '-created_at';
        const params = {
            page,
            ordering: sortOrder,
            start_date: startDate,
            end_date: endDate,
            page_size: pageSize
        };
        axios.get(`/api/mesh`, {params})
            .then(response => {
                console.log(response.data)
                setData(response.data.results);
                setTotalPages(Math.ceil(response.data.count / pageSize));
            })
            .catch(error => {
                console.error("Error fetching data: ", error);
            });
    };

    const handleSortClick = () => {
        setSortAsc(!sortAsc);
    };


    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);  // Сбросить на первую страницу при фильтрации
        fetchData(1, sortAsc, startDate, endDate, pageSize);
    };


    return (
        <>
            <InfoModal
                isOpen={modalIsOpen}
                modalTitle={'Mesh creating'}
                onRequestClose={closeModal}
                body={modalBody}
                contentLabel="Example Modal">
            </InfoModal>
            <Header/>
            {/* Page content */}
            <Container className="mt--7" fluid>
                {/* Table */}
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">{t('MESHDesc')}</h3>
                            </CardHeader>
                            {uploading ? (<Loader active={uploading}>
                                {cardBody()}
                            </Loader>) : (cardBody())}


                            <CardFooter className="py-4">
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
                <Row style={{marginTop: "16px"}}>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">{t('MeshHistory')}</h3>
                                <Form inline onSubmit={handleFilterSubmit}>
                                    <FormGroup>
                                        <Label for="startDate">{t('StartDate')}</Label>
                                        <Input
                                            type="date"
                                            name="startDate"
                                            id="startDate"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="endDate">{t('EndDate')}</Label>
                                        <Input
                                            type="date"
                                            name="endDate"
                                            id="endDate"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="pageSize">{t('PageSize')}</Label>
                                        <Input
                                            type="number"
                                            name="pageSize"
                                            id="pageSize"
                                            value={pageSize}
                                            onChange={(e) => {
                                                if (e.target.value !== "") {
                                                    const pages_size = Number(e.target.value)
                                                    setPageSize(Math.max(1, pages_size))
                                                }
                                            }}
                                            min="1"
                                        />
                                    </FormGroup>
                                    <Button type="submit">{t('Filter')}</Button>
                                </Form>
                            </CardHeader>
                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                <tr>
                                    <th scope="col" onClick={handleSortClick} style={{cursor: 'pointer'}}>{t('StartedDate')}: {sortAsc ?
                                            <i className="ni ni-bold-up"/> :
                                            <i className="ni ni-bold-down"/>}</th>
                                    <th scope="col">{t('CalculationStatus')}:</th>
                                    <th scope="col">input T1</th>
                                    <th scope="col">input T2</th>
                                    <th scope="col">{t('FullLogs')}:</th>
                                    <th scope="col">{t('ResultMesh')}:</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.map((operation, index) => {
                                    const date = new Date(operation.created_at);
                                    return (
                                        <tr key={index}>
                                            <td>{date.toLocaleDateString()} {date.toLocaleTimeString()}</td>
                                            <td>
                                                {(operation.status === 'Fail') ? (
                                                    <h6 className="text-xs font-weight-bold mb-0">
                                                        <font color="red">{operation.status}</font>
                                                    </h6>

                                                ) : (
                                                    <h6 className="text-xs font-weight-bold mb-0">
                                                        <font color="green">{operation.status}</font>
                                                    </h6>
                                                )}
                                            </td>
                                            <td>{operation.input_t1 ?
                                                <a href={operation.input_t1}>Download</a> : "-"} </td>
                                            <td>{operation.input_t2 ?
                                                <a href={operation.input_t1}>Download</a> : "-"} </td>
                                            <td>{operation.log_file ?
                                                <a href={operation.log_file}>Download</a> : "-"} </td>
                                            <td>{operation.mesh ?
                                                <a href={operation.mesh}>See</a> : "-"} </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                            <CardFooter className="py-4">
                                <nav aria-label="...">
                                    <Pagination className="pagination justify-content-end mb-0">
                                        <PaginationItem disabled={currentPage === 1}>
                                            <PaginationLink
                                                href="#pablo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (currentPage > 1) setCurrentPage(currentPage - 1);
                                                }}
                                                tabIndex="-1"
                                            >
                                                <i className="fas fa-angle-left"/>
                                                <span className="sr-only">Previous</span>
                                            </PaginationLink>
                                        </PaginationItem>
                                        {[...Array(totalPages).keys()].map(page => (
                                            <PaginationItem key={page + 1} active={page + 1 === currentPage}>
                                                <PaginationLink
                                                    href="#pablo"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setCurrentPage(page + 1);
                                                    }}
                                                >
                                                    {page + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        ))}
                                        <PaginationItem disabled={currentPage === totalPages}>
                                            <PaginationLink
                                                href="#pablo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                                                }}
                                            >
                                                <i className="fas fa-angle-right"/>
                                                <span className="sr-only">Next</span>
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </nav>
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    )
}

export default MeshConverter;